import { format, isValid } from 'date-fns';
import * as React from 'react';
import { type ITimeElementProps } from './TimeElement.types';

/**
 * Wraps the html time element by providing additional validation logic. The format of dateTimeString is not validated.
 * @returns The time element or null if invalid date or empty dateTimeString is sent.
 */
export const TimeElement: React.FC<ITimeElementProps> = ({
    date,
    dateTimeString,
    additionalAttributes,
    children,
    dateTimeFormat = "yyyy-MM-dd'T'HH:mm:ssxxx",
}) => {
    const hasValidDate = date !== undefined && date !== null && isValid(date);
    const hasValidString = dateTimeString !== undefined && dateTimeString !== null && dateTimeString.length > 0;

    if (!hasValidDate && !hasValidString) {
        return null;
    }

    return (
        <time dateTime={dateTimeString || format(date, dateTimeFormat)} {...additionalAttributes}>
            {children}
        </time>
    );
};
